import { useRouterEvents } from "../hooks/useRouterEvents.js";
/**
 * Enables scroll restoration when navigation backwards, as well as resetting scroll position when navigating forwards.
 */
export function ScrollRestoration(props) {
    const restore = props.restore ??
        ((scroll) => document.scrollingElement?.scrollTo({
            behavior: props.behaviour ?? "instant",
            left: scroll.left,
            top: scroll.top,
        }));
    useRouterEvents((event) => {
        if (event.type === "navigate:changed") {
            // If the pathname and search term are the same, then we're on the same page
            const isSameRoute = event.currentRoute.pathname === event.lastRoute.pathname && event.currentRoute.search === event.lastRoute.search;
            if (isSameRoute)
                return;
            if (event.currentRoute.returnState) {
                restore({
                    top: event.currentRoute.returnState.scrollTop ?? 0,
                    left: event.currentRoute.returnState.scrollLeft ?? 0,
                    direction: "back",
                });
            }
            else {
                restore({
                    top: 0,
                    left: 0,
                    direction: "forward",
                });
            }
        }
    });
    return null;
}
